<template>
  <div></div>
</template>
<script>
import {
  saveAccount
} from '@/libs/utils'
export default {
  data() {
    return {

    }
  },
  mounted() {
    let userList = this.$route.query.userList;
    if (userList) {
      userList = JSON.parse(userList)
      for (let i = userList.length - 1; i >= 0; i--) {
        saveAccount(userList[i].username, userList[i].password)
      }
    }
  }
}
</script>

